<div class="humehealth__header__logo">
  <img *ngIf="mediaUrl" src="{{ mediaUrl }}" alt="logo">
</div>
